module.exports = __webpack_public_path__ + "static/media/Vector.204fd4a5.svg";